import { BaseCurrencyConfig } from '@web/walter-lib/api/types/cms/config/returnTypes'
import { useCommonCMSConfig } from '~api'

export const defaultBaseCurrencies: BaseCurrencyConfig[] = [
    {
        code: 'USD',
        name: 'US Dollar',
        sign: '$',
        codeForRateCalculations: 'USDT',
        useIntlCurrencyStyle: true,
    },
]

export const useBaseCurrenciesList = () => {
    return useCommonCMSConfig().data?.baseCurrencies || defaultBaseCurrencies
}
